export default "__VITE_ASSET__CN$WdskP__"